import React, { useEffect, useState } from "react";
import {
  FiRefreshCw,
  FiPlus,
  FiEdit2,
  FiTrash2,
  FiCheckCircle,
} from "react-icons/fi";
import {
  Card,
  Col,
  CardHeader,
  Row,
 
} from "reactstrap";
import api from "../../utills/api";
import BreadCrumb from "../../Components/Common/BreadCrumb";

const EMPTY_FORM = {
  name: "",
  description: "",
  color: "",
  order: 0,
  isActive: true,
};

const Statuses = () => {
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingStatus, setEditingStatus] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);

  const loadStatuses = async () => {
    try {
      setLoading(true);

      const response = await api.get("/lead-statuses");

      const data =
        response?.data?.data?.statuses ||
        response?.data?.data ||
        response?.data ||
        [];

      setStatuses(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Failed to load statuses:", error);
      setStatuses([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStatuses();
  }, []);

  const openCreate = () => {
    setEditingStatus(null);
    setForm(EMPTY_FORM);
    setModalOpen(true);
  };

  const openEdit = (status) => {
    setEditingStatus(status);

    setForm({
      name: status.name || "",
      description: status.description || "",
      color: status.color || "",
      order: status.order || 0,
      isActive: status.isActive !== false,
    });

    setModalOpen(true);
  };

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;

    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const saveStatus = async (event) => {
    event.preventDefault();

    try {
      if (editingStatus) {
        await api.put(
          `/lead-statuses/${
            editingStatus._id || editingStatus.id
          }`,
          form
        );
      } else {
        await api.post("/lead-statuses", form);
      }

      setModalOpen(false);
      await loadStatuses();
    } catch (error) {
      console.error("Failed to save status:", error);

      alert(
        error?.response?.data?.message ||
          "Unable to save lead status."
      );
    }
  };

  const deleteStatus = async (status) => {
    const id = status._id || status.id;

    if (!window.confirm(`Delete "${status.name}"?`)) {
      return;
    }

    try {
      await api.delete(`/lead-statuses/${id}`);
      await loadStatuses();
    } catch (error) {
      console.error("Failed to delete status:", error);

      alert(
        error?.response?.data?.message ||
          "Unable to delete lead status."
      );
    }
  };

  document.title =
    "Statuses | eduLeads.Online";

  return (
    <div className="page-content">
      <div className="container-fluid">
                      <BreadCrumb
          title="Statuses"
          pageTitle="Settings"
        />

                   <Row>
          <Col lg={12}>
            <Card>
              <CardHeader>
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <div className="flex-grow-1">
                    <h5 className="mb-0">
Lead Statuses                    </h5>

                    <small className="text-muted">
                      Configure the lead lifecycle used by counsellors.
                    </small>
                  </div>
                </div>
               
              </CardHeader>
            </Card>
          </Col>
        </Row>
       

        <div className="card">
          <div className="card-body">
            {loading ? (
              <div className="text-center py-5">
                Loading statuses...
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Order</th>
                      <th>Status</th>
                      <th>Description</th>
                      <th>Active</th>
                      <th className="text-end">
                        Actions
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {statuses.length === 0 ? (
                      <tr>
                        <td
                          colSpan="5"
                          className="text-center text-muted py-5"
                        >
                          No lead statuses found.
                        </td>
                      </tr>
                    ) : (
                      statuses.map((status) => {
                        const id = status._id || status.id;

                        return (
                          <tr key={id}>
                            <td>
                              {status.order ?? "—"}
                            </td>

                            <td>
                              <span
                                className="badge"
                                style={{
                                  backgroundColor:
                                    status.color ||
                                    "#6c757d",
                                }}
                              >
                                {status.name}
                              </span>
                            </td>

                            <td>
                              {status.description || "—"}
                            </td>

                            <td>
                              {status.isActive === false ? (
                                <span className="text-danger">
                                  Inactive
                                </span>
                              ) : (
                                <span className="text-success">
                                  <FiCheckCircle
                                    size={15}
                                    className="me-1"
                                  />
                                  Active
                                </span>
                              )}
                            </td>

                            <td className="text-end">
                              <button
                                className="btn btn-sm btn-light me-1"
                                onClick={() =>
                                  openEdit(status)
                                }
                              >
                                <FiEdit2 size={14} />
                              </button>

                              <button
                                className="btn btn-sm btn-light text-danger"
                                onClick={() =>
                                  deleteStatus(status)
                                }
                              >
                                <FiTrash2 size={14} />
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {modalOpen && (
          <div
            className="modal d-block"
            style={{
              backgroundColor: "rgba(0,0,0,.45)",
            }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <form onSubmit={saveStatus}>
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {editingStatus
                        ? "Edit Lead Status"
                        : "Add Lead Status"}
                    </h5>

                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setModalOpen(false)}
                    />
                  </div>

                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">
                        Status Name
                      </label>

                      <input
                        name="name"
                        className="form-control"
                        value={form.name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        Description
                      </label>

                      <textarea
                        name="description"
                        className="form-control"
                        rows="3"
                        value={form.description}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          Color
                        </label>

                        <input
                          type="text"
                          name="color"
                          className="form-control"
                          placeholder="#405189"
                          value={form.color}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          Order
                        </label>

                        <input
                          type="number"
                          name="order"
                          className="form-control"
                          value={form.order}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="form-check">
                      <input
                        type="checkbox"
                        name="isActive"
                        className="form-check-input"
                        checked={form.isActive}
                        onChange={handleChange}
                        id="statusActive"
                      />

                      <label
                        className="form-check-label"
                        htmlFor="statusActive"
                      >
                        Active
                      </label>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-light"
                      onClick={() => setModalOpen(false)}
                    >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className="btn btn-primary"
                    >
                      {editingStatus
                        ? "Update Status"
                        : "Create Status"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Statuses;